import { render, staticRenderFns } from "./online_purchase_list.vue?vue&type=template&id=72688a1b&scoped=true"
import script from "./online_purchase_list.vue?vue&type=script&lang=js"
export * from "./online_purchase_list.vue?vue&type=script&lang=js"
import style0 from "./online_purchase_list.vue?vue&type=style&index=0&id=72688a1b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72688a1b",
  null
  
)

export default component.exports